import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MarkdownImageIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { isUrl } from '@udecode/plate';
import { ImagePlugin } from '@udecode/plate-media/react';
import { useEditorRef } from '@udecode/plate/react';
import { useState } from 'react';
import { Dialog } from '../Dialog';
import { Input } from '../Input';
import { Stack } from '../Layout';
import { toast } from '../Toast';
import { StyledButton } from './styled';
import { useToolbarButtonClick } from './utils';
function ImageUrlDialog({ open, onClose }) {
    const editor = useEditorRef();
    const [url, setUrl] = useState('');
    const [caption, setCaption] = useState('');
    const embedMedia = () => {
        if (!isUrl(url))
            return toast.error({ content: 'Invalid URL', 'data-test-id': 'markdown-editor-invalid-url-toast' });
        onClose();
        editor.tf.insertNodes({
            children: [{ text: '' }],
            name: undefined,
            type: ImagePlugin.key,
            alt: caption,
            url
        });
        setUrl('');
        setCaption('');
    };
    return (_jsx(Dialog, { open: open, onClose: onClose, onOk: embedMedia, size: 'l', title: 'Insert Image', okButton: {
            children: 'Insert'
        }, "data-test-id": 'markdown-editor-insert-image-dialog', children: _jsxs(Stack, { padding: `${theme.spaces.x12} ${theme.outlineWidth}`, gap: theme.spaces.x12, children: [_jsx(Input, { label: 'Image URL', iconPlacement: 'left', placeholder: 'https://example.com/image.png', value: url, onChange: (url) => setUrl(url), onPressEnter: embedMedia, "data-test-id": 'markdown-editor-image-url-input' }), _jsx(Input, { label: 'Image Caption', placeholder: 'Description of the image', value: caption, onChange: (caption) => setCaption(caption), "data-test-id": 'markdown-editor-image-caption-input' })] }) }));
}
export function InsertImageButton() {
    const [open, setOpen] = useState(false);
    const onClick = useToolbarButtonClick(() => setOpen(true));
    return (_jsxs(_Fragment, { children: [_jsx(StyledButton, { variant: 'tertiaryGray', size: 'm', icon: _jsx(MarkdownImageIcon, { type: 'extended' }), onClick: onClick, "aria-label": 'Insert image', "data-test-id": 'markdown-editor-insert-image-button' }), _jsx(ImageUrlDialog, { open: open, onClose: () => setOpen(false) })] }));
}
